import type { RouteRecordRaw } from 'vue-router';

export const collectRoute: RouteRecordRaw = {
  path: '/collect',
  name: 'Collect',
  component: () => import('./pages/CollectPage.vue'),
  meta: { layout: 'main', step: 'collect' },
};

export const auditRoute: RouteRecordRaw = {
  path: '/audit',
  name: 'Audit',
  component: () => import('./pages/AuditPage.vue'),
  meta: { layout: 'main', step: 'audit' },
};

export const reportRoute: RouteRecordRaw = {
  path: '/report',
  name: 'Report',
  component: () => import('./pages/ReportPage.vue'),
  meta: { layout: 'main', step: 'report' },
};
